<template>
  <div class="appPageSpinner">
    <div class="spinner-border" />
    <div class="spinner-message global-main-2" v-if="message">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AppPageSpinner",
  props: {
    message: String,
  },
};
</script>

<style lang="scss">
.appPageSpinner {
  background-color: var(--color-bg);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@-webkit-keyframes spinner-border {
  to {
    -webkit-transform: rotate(360deg) /* rtl:ignore */;
    transform: rotate(360deg) /* rtl:ignore */;
  }
}

@keyframes spinner-border {
  to {
    -webkit-transform: rotate(360deg) /* rtl:ignore */;
    transform: rotate(360deg) /* rtl:ignore */;
  }
}

.spinner-border {
  color: var(--color-text);
  display: inline-block;
  width: 48px;
  height: 48px;
  vertical-align: -0.125em;
  border: 3px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite spinner-border;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-message {
  color: var(--color-text);
  margin-top: 20px;
}
</style>
